module.exports = __webpack_public_path__ + "static/img/电子文件签名验证平台.07ae121.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/电子文件签名验证平台.jpg
// module id = sGdq
// module chunks = 15